import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux';
import { userSelectors } from '../redux/user';
import { isStatusIdle } from '../utils';
import { applyPosition, positionsSelectors } from 'src/redux/positions';
import { useIsStandalonePage } from './useIsStandalonePage';

export const usePositionData = (withApply = false) => {
  const dispatch = useAppDispatch();
  const isStandalonePage = useIsStandalonePage();

  const userData = useAppSelector(userSelectors.getUserData);
  const apiStatus = useAppSelector(positionsSelectors.getPositionsApiStatus);
  const positionData = useAppSelector(positionsSelectors.getPositionData);

  const userDisplayablePositions =
    userData?.positions?.filter((x) => x.isDisplayable) ?? [];
  const positionDataUser =
    userDisplayablePositions.length > 0
      ? userDisplayablePositions[userDisplayablePositions.length - 1]
      : null;

  useEffect(() => {
    if (
      !isStandalonePage &&
      positionData?.isDisplayable &&
      userData &&
      !positionDataUser &&
      isStatusIdle(apiStatus) &&
      withApply
    ) {
      dispatch(applyPosition(positionData));
    }
  }, [positionData, userData, positionDataUser, apiStatus, isStandalonePage]);

  return positionDataUser || positionData;
};
